export const CREATE_TILLER_BACK_OFFICE = 'CREATE_TILLER_BACK_OFFICE';
export const BACK_OFFICE_CREATED = 'BACK_OFFICE_CREATED';
export const ERROR_CREATE_BACK_OFFICE = 'ERROR_CREATE_BACK_OFFICE';
export const BACK_OFFICE_ID_SENT_TO_SALESFORCE = 'BACK_OFFICE_ID_SENT_TO_SALESFORCE';

export function askForBackOfficeCreation() {
  return {
    type: CREATE_TILLER_BACK_OFFICE,
  };
}



// WEBPACK FOOTER //
// ./src/services/TillerBackService/actions.js